import React from "react";
import * as SC from "./Box.styles";

export enum BoxType {
  INFO = "info",
  ERROR = "error",
  FLAT = "flat",
  ROUNDED_BORDER = "ROUNDED_BORDER",
}

interface BoxProps {
  width?: string;
  height?: string;
  padding?: string;
  margin?: string;
  type: BoxType;
  children: React.ReactNode;
}
export const Box = ({
  width,
  height,
  type,
  padding,
  margin,
  children,
}: BoxProps) => {
  return (
    <SC.BoxContainer
      width={width}
      height={height}
      type={type}
      padding={padding}
      margin={margin}
    >
      {children}
    </SC.BoxContainer>
  );
};
